import { fromJS } from 'immutable';
import { SET_LOGGED_IN, SET_PASSWORD_RESET_TOKEN, SET_UID, SET_VALID_ONE_TIME_LOGIN } from '../../actions/Login';
var initialState = fromJS({
  loggedIn: null,
  // Null by default to negotiate login state in your app.
  validOneTimeLogin: null,
  // Null by default to negotiate login state in your app.
  passResetToken: null,
  uid: {}
});
export default function login() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case SET_LOGGED_IN:
      {
        return state.set('loggedIn', fromJS(action.data));
      }
    case SET_UID:
      {
        return state.set('uid', fromJS(action.data));
      }
    case SET_VALID_ONE_TIME_LOGIN:
      {
        return state.set('validOneTimeLogin', fromJS(action.data));
      }
    case SET_PASSWORD_RESET_TOKEN:
      {
        return state.set('passResetToken', fromJS(action.data));
      }
    default:
      return state;
  }
}